import React from 'react'
import Button from '../Button'

import styles from './Confirmation.module.scss'

const Confirmation = () => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.headerContainer}>
        <h1>Thank you!</h1>
      </div>
      <div className={styles.confirmation}>
        <p className={styles.confirmationText}>
          Your request was successfully submitted.
        </p>
        <Button
          active={false}
          className={styles.confirmationButton}
          disabled={false}
          link={process.env.REACT_APP_RETURN_URL}
          onClick={() => null}
          text={'Back to Buyatoyota.com'}
          type={'Submit'} />
      </div>
    </div>
  )
}

export default Confirmation;
